module.exports = __webpack_public_path__ + "static/media/18ECA49.2d4000c8.jpg";